// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__Ze1EW","resendInfoText":"OnGoingPaymentBox_resendInfoText__Xg6sp"};